/*
 * Opens a popup.
 *
 * Based on (and then modified from) https://github.com/mkdynamic/jquery-popupwindow/blob/master/jquery.popupwindow.js
 *
 * Opens full height and with a max width of 2170px.
 */
export function openPopupWindow(url: string, windowName: string): Window | null {
    if (import.meta.server) return null

    let windowReference: Window | null
    const settings: {
        centerBrowser: 0 | 1
        centerScreen: number
        height: number
        left: number
        location: 0 | 1
        menubar: 0 | 1
        resizable: 0 | 1
        scrollbars: 0 | 1
        status: 0 | 1
        width: number
        windowURL?: string
        windowName?: string
        top: number
        toolbar: number
    } = {
        centerBrowser: 0, // center window over browser window? {1 (YES) or 0 (NO)}. overrides top and left
        centerScreen: 0, // center window over entire screen? {1 (YES) or 0 (NO)}. overrides top and left
        height: screen.availHeight, // sets the height in pixels of the window.
        left: 0, // left position when the window appears.
        location: 0, // determines whether the address bar is displayed {1 (YES) or 0 (NO)}.
        menubar: 0, // determines whether the menu bar is displayed {1 (YES) or 0 (NO)}.
        resizable: 1, // whether the window can be resized {1 (YES) or 0 (NO)}. Can also be overloaded using resizable.
        scrollbars: 0, // determines whether scrollbars appear on the window {1 (YES) or 0 (NO)}.
        status: 0, // whether a status line appears at the bottom of the window {1 (YES) or 0 (NO)}.
        width: screen.availWidth > (1920 + 250) ? (1920 + 250) : screen.availWidth, // Limit width to 1920px (max reasonable size of games) + 250px (chat)
        windowName: undefined, // name of window set from the name attribute of the element that invokes the click
        windowURL: undefined, // url used for the popup
        top: 0, // top position when the window appears.
        toolbar: 0, // determines whether a toolbar (includes the forward and back buttons) is displayed {1 (YES) or 0 (NO)}.
    }

    const windowFeatures = `height=${settings.height}`
        + `width=${settings.width}`
        + `toolbar=${settings.toolbar}`
        + `scrollbars=${settings.scrollbars}`
        + `status=${settings.status}`
        + `resizable=${settings.resizable}`
        + `location=${settings.location}`
        + `menuBar=${settings.menubar}`

    settings.windowURL = url
    settings.windowName = windowName

    let centeredY,
        centeredX

    if (settings.centerBrowser) {
        if (typeof window.screenX === 'undefined' || typeof window.screenY === 'undefined') {
            centeredY = (window.screenTop - 120) + ((((document.documentElement.clientHeight + 120) / 2) - (settings.height / 2)))
            centeredX = window.screenLeft + ((((document.body.offsetWidth + 20) / 2) - (settings.width / 2)))
        }
        else {
            centeredY = window.screenY + (((window.outerHeight / 2) - (settings.height / 2)))
            centeredX = window.screenX + (((window.outerWidth / 2) - (settings.width / 2)))
        }

        windowReference = window.open(settings.windowURL, settings.windowName, `${windowFeatures},left=${centeredX},top=${centeredY}`)
    }
    else if (settings.centerScreen) {
        centeredY = (screen.height - settings.height) / 2
        centeredX = (screen.width - settings.width) / 2
        windowReference = window.open(settings.windowURL, settings.windowName, `${windowFeatures},left=${centeredX},top=${centeredY}`)
    }
    else {
        windowReference = window.open(settings.windowURL, settings.windowName, `${windowFeatures},left=${settings.left},top=${settings.top}`)
    }

    if (windowReference) {
        windowReference.focus()
    }

    return windowReference
}
